import Config from 'config';
import QueryString from 'qs';
import ApiaApi from '../../../../api/apiaApi/apiaApi';
import { TApiaFinderGetRowResponse } from '../../../../components/apia/execution/fields/apiaFinder/types';
import { arrayOrArray } from '../../../../utils/util';

const getRowData = async ({
  rowId,
  ajaxUrl,
}: {
  ajaxUrl: string;
  rowId: number | string;
}) => {
  const firstResponse = await ApiaApi.post<TApiaFinderGetRowResponse>(
    Config.FINDER_SELECT_ROW_GET_DATA(ajaxUrl),
    {
      notificationsCategory: 'apiaFinder',
      postData: QueryString.stringify({ id: rowId }),
    },
  );
  if (firstResponse && firstResponse.data) {
    const rawRow = arrayOrArray(firstResponse.data.row.cell);
    const [storeValue, showValue, ...fields] = rawRow;

    return { storeValue, showValue, fields };
  }
  throw new Error();
};

export default getRowData;
